import LoggedIn from './UserMenuLoggedIn'
import LoggedOut from './UserMenuLoggedOut'

export default {
  LoggedIn,
  LoggedOut,
}
